import { render, staticRenderFns } from "./room-rate.vue?vue&type=template&id=821cf2dc&"
import script from "./room-rate.vue?vue&type=script&lang=js&"
export * from "./room-rate.vue?vue&type=script&lang=js&"
import style0 from "./room-rate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports